
import { Component, OnInit } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { LeftPanelService } from '../services/left-panel.service';
import { UserService } from '../../../core/security/user.service';
import { NavigationService } from '../../../core/navigation.service';
import { AlertService, LoggerService, ResourceService } from 'sce-core';
import { ConfirmDialogService } from 'sce-core';
import { environment } from '../../../../environments/environment.sit';
import { saveAs } from 'file-saver'; // Don't forget to import the file-saver
import { HelpPopupComponent } from '../help-popup/help-popup.component';
import { SharedServiceRegistry } from '../../../shared/shared-service-registry';
import { ReceiptDataService } from '../../../shared/services/receipt/receipt-data.service';

@Component({
  selector: 'lfwms-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css'],
  animations: [
    trigger('openClose', [
      state('open', style({
        right: '350px',
      })),
      state('closed', style({
        right: '0px'
      })),
      transition('open => closed', [
        animate('0.5s')
      ]),
      transition('closed => open', [
        animate('0.5s')
      ]),
    ])
  ]
})
export class ProfileComponent implements OnInit {

  public displayName: string;
  public displayCountry: any = {};
  public displayLanguage: any = {};
  public show: boolean = false;
  public cntryDropDownShow: boolean;
  public langDropDownShow: boolean;
  public image_user = 'assets/images/icon-person.png';
  public displayPhotoBool: boolean = false;

  public countries: any[];
  public  languages: any[];
  private storers: any[];
  private selectedCountry: number;
  private selectedLanguage: number;
  private selectedStorer: string;
  private showErrorLog: boolean;
  public tooltipPosition: string = 'left';
  public tooltipMessageServerName: string = 'Server Name';
  public tooltipMessageDBName: string = 'DB Name';

  protected dataService: ReceiptDataService;

  constructor(private userService: UserService,
    private navService: NavigationService,
    private confirmDialogService: ConfirmDialogService,
    private resourceService: ResourceService,
    public leftPanelService: LeftPanelService,
    public loggerService: LoggerService,
    public alertService: AlertService,
    protected sharedServiceRegistry: SharedServiceRegistry) {
  }

  // method used to translate the labels
  public getLabel(key: any) {
    return this.resourceService.get(key);
  }

  public ngOnInit() {
    this.getDbServerDetails();
    this.updateUserPreference();
    this.displayName = this.userService.userInfo.displayName;
    if (this.userService.userInfo.photo) {
    this.image_user = this.userService.userInfo.photo;
    this.displayPhotoBool = true;
    }
  }

  // Logs the user out
  public logout() {
    if (this.navService.preventNavigation) {
      const dialogMsg = [`<b>` + this.resourceService.get('mn_data_lost_msg') + `</b>`, this.resourceService.get('mn_nav_confirm_msg')];
      this.confirmDialogService.confirmDialog(this.resourceService.get(dialogMsg)).subscribe((isConfirmed) => {
        if (!isConfirmed) {
          return false;
        }
        this.navService.preventNavigation = false;
        this.userService.logout();

       });
      return;
    }
    // else
    this.userService.logout();
  }

  /* Save the selected language to backend.
    this.saveCntryLang() reloads homepage */
  private saveLang(language: any) {
    if (this.navService.preventNavigation) {
      const dialogMsg = [`<b>` + this.resourceService.get('mn_data_lost_msg') + `</b>`, this.resourceService.get('mn_nav_confirm_msg')];
      this.confirmDialogService.confirmDialog(this.resourceService.get(dialogMsg)).subscribe((isConfirmed) => {
        if (!isConfirmed) {
          return false;
        }
        this.navService.preventNavigation = false;
        this.selectedLanguage = language.languageId;
        this.displayLanguage = language;
        this.saveCntryLang();

       });
      return;
    }
    // else
    this.selectedLanguage = language.languageId;
    this.displayLanguage = language;
    this.saveCntryLang();
  }

  /* Save the selected country to backend.
    this.saveCntryLang() reloads homepage */
  private saveCntry(country: any) {
    if (this.navService.preventNavigation) {
      const dialogMsg = [`<b>` + this.resourceService.get('mn_data_lost_msg') + `</b>`, this.resourceService.get('mn_nav_confirm_msg')];
      this.confirmDialogService.confirmDialog(this.resourceService.get(dialogMsg)).subscribe((isConfirmed) => {
        if (!isConfirmed) {
          return false;
        }
        this.navService.preventNavigation = false;

          this.selectedCountry = country.countryId;
          this.displayCountry = country;
          this.saveCntryLang();

       });
      return;
    }
    // else
    this.selectedCountry = country.countryId;
    this.displayCountry = country;
    this.saveCntryLang();
  }

  /* This methods reads currently selected countryId and languageId
  and calls update preferences method for the user.
  Once save call is successfull it reloads homepage.*/
  private saveCntryLang() {
   // this.selectedLanguage = Number(this.selectedLanguage);
    this.userService.updatePreferences(
      this.selectedCountry,
      this.selectedLanguage)
      .subscribe((data: any) => {
        if(data && data.baseUrl && data.baseUrl !== window.location.origin ){
          window.location.href = data.baseUrl;
        } else {
          window.location.href = environment.baseUrlUI; // SIT URL changed
        }
      });
  }
   /*  This function fetches and sets Country list and Language list
    for use in Cntry/Lang change dropdowns */
  private retrieveCountryLangList() {
    this.userService.getEnabledCountries()
      .subscribe((data: any) => {
        this.countries = data;
        this.countries = this.countries.filter((cntry: any) => {
          return cntry.countryId !== this.userService.userInfo.defaultCountry;
        });
        for (const country of data) {
          if (country.countryId === this.userService.userInfo.defaultCountry) {
            this.displayCountry = country;
            break;
          }
        }
      });
    this.userService.getAllLanguages()
      .subscribe((data: any) => {
        this.languages = data;
        this.languages = this.languages.filter((lang: any) => {
          return lang.languageId !== this.userService.userInfo.defaultLanguage;
        });
        for (const language of data) {
          if (language.languageId === this.userService.userInfo.defaultLanguage) {
            this.displayLanguage = language;
            break;
          }
        }
      });
    this.selectedCountry = this.userService.userInfo.defaultCountry;
    this.selectedLanguage = this.userService.userInfo.defaultLanguage;
    this.storers = ['NIKE', 'nike1'];
    this.selectedStorer = 'NIKE';
    // this.userService.userInfo.userRestrictions
  }
  public updateUserPreference(){
    this.userService.getUserPreferences()
    .subscribe((data: any) => {
      if(data.defaultCountryId != this.userService.userInfo.defaultCountry ){
        this.selectedCountry = data.defaultCountryId;
        this.selectedLanguage = data.defaultLanguageId;
        this.saveCntryLang();
      } else {
        this.retrieveCountryLangList();
      }
    });
  }
  public downloadErrorLog() {
    let log  = this.loggerService.errorLog.toString();
    if(log === ""){
      this.alertService.clearAll().warn(this.resourceService.translateServerResponse("msg_error_log"));
    } else {
      saveAs(new Blob([log], { type: "text" }), 'error.log');
    }
    // this.loggerService.errorLog = [];

  }

  public getDbServerDetails() {
    this.userService.getDbDetails()
    .subscribe((data: any) => {
      if (data && data.database && data.server) {
        this.tooltipMessageServerName = data.server;
        this.tooltipMessageDBName = data.database;
      }
    });
  }

  public helpPopup() {
    this.alertService.clearAll();
    const modalRef: any = this.sharedServiceRegistry.sceModalService
      .showModal(HelpPopupComponent,
        {
          overlayHeader: 'Help',
          showHeader: true,
          overlayHeight: 520,
          overlayWidth: 840
        });
        modalRef.content.initialize();
    // modalRef.content.showLookup = true;
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/layout/home/profile/profile.component.ts